import { formatNumber } from '@/lib/helpers';
import type { Automation } from '../types/automation.types';

export interface AutomationAnalyticsData {
    sent: number;
    clicks: number;
    purchases: number;
}

/**
 * Calculate total clicks from clicks object
 * Backend returns clicks as object with link IDs as keys
 */
export function calculateTotalClicks(clicks: Record<string, number> | undefined): number {
    if (!clicks) return 0;
    return Object.values(clicks).reduce((sum, count) => sum + count, 0);
}

/**
 * Format analytics count with optional compact notation
 */
export function formatAnalyticsCount(count: number, compact = true): string {
    return formatNumber(count, { compact });
}

/**
 * Get complete analytics data for an automation
 * Returns formatted data ready for display
 */
export function getAutomationAnalyticsData(automation: Automation): AutomationAnalyticsData {
    // Get sent count from analytics
    const sent = automation.analytics?.sent ?? 0;

    // Calculate total clicks from analytics clicks object
    const totalClicks = calculateTotalClicks(automation.analytics?.clicks);

    // Get purchases from analytics
    const purchases = automation.analytics?.purchases ?? 0;

    return {
        sent,
        clicks: totalClicks,
        purchases,
    };
}
